export const contactsData = {
    sheetAPI: process.env.REACT_APP_SHEET_API,
  };